import PropTypes from 'prop-types';

import { toFormattedOfferOldPrice, toFormattedOfferPrice } from 'lib/offer';

import Price from '../../Home/Shopper/Price';

const OfferPrice = ({ offerOldPrice = null, offerPrice, offerPriceType }) => (
  <Price
    className="flex-row-reverse items-center gap-x-1"
    primaryInfo={toFormattedOfferPrice(offerPrice, offerPriceType)}
    secondaryInfo={toFormattedOfferOldPrice(offerOldPrice, offerPriceType)}
    size="large"
  />
);

OfferPrice.propTypes = {
  offerOldPrice: PropTypes.number,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
};

export default OfferPrice;
